import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "role-tree w100"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElTree } from 'element-plus';
import useRoleStore from '@/store/modules/role';
import { storeToRefs } from 'pinia';
import { setStatusApi, updateStatusApi } from '@/service/modules/role';
export default /*@__PURE__*/_defineComponent({
  __name: 'role-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: 'addSubset'
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const treeRef = ref();
    const roleStore = useRoleStore();
    const {
      allPermissionList
    } = storeToRefs(roleStore);
    const subBtnLoading = ref(false);
    const treeCheckStrictly = ref(true);
    const form = reactive({
      id: null,
      roleName: '',
      perIds: [],
      status: 1
    });
    const rules = {
      roleName: [{
        required: true,
        message: '请输入角色名称',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '请选择启用状态',
        trigger: 'change'
      }],
      perIds: [{
        required: true,
        message: '请为角色分配权限',
        trigger: 'change'
      }, {
        validator: perIdsValidator,
        trigger: 'blur'
      }]
    };
    function perIdsValidator(rule, value, callback) {
      if (form.perIds.length === 0) {
        callback(new Error('请为角色分配权限'));
      } else {
        callback();
      }
    }
    function restForm() {
      form.id = null;
      form.roleName = '';
      form.perIds = [];
      form.status = 1;
      treeRef.value.setCheckedKeys([], false);
      subBtnLoading.value = false;
      treeCheckStrictly.value = true;
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      formRef.value?.resetFields();
      emit('closeDialog');
    }
    async function submit() {
      subBtnLoading.value = true;
      let query = JSON.parse(JSON.stringify(form));
      query.perIds = query.perIds.join(',');
      try {
        if (props.dialogType === 'add') {
          delete query.id;
          let res = await setStatusApi(query);
        } else if (props.dialogType === 'edit') {
          let res = await updateStatusApi(query);
        }
        ElMessage.success(props.dialogType === 'add' ? '添加成功' : '修改成功');
        restForm();
        formRef.value?.resetFields();
        emit('restData');
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    function handleElCheck(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      let keys = [];
      if (checkedKeys.checkedKeys && checkedKeys.checkedKeys.length > 0) {
        keys = keys.concat(checkedKeys.checkedKeys);
      }
      if (checkedKeys.halfCheckedKeys && checkedKeys.halfCheckedKeys.length > 0) {
        keys = keys.concat(checkedKeys.halfCheckedKeys);
      }
      form.perIds = keys;
    }
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '添加账号';
      } else if (props.dialogType === 'edit') {
        return '编辑账号';
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          if (props.dialogType === 'edit') {
            for (let key in form) {
              if (key === 'perIds') {
                form[key] = props.itemData[key] ? props.itemData[key].split(',') : [];
              } else {
                form[key] = props.itemData[key];
              }
            }
            treeRef.value.setCheckedKeys(form.perIds, false);
          }
          setTimeout(() => {
            treeCheckStrictly.value = false;
          });
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "roleName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: [1, 2].includes(form.id),
              modelValue: form.roleName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.roleName = $event),
              placeholder: "请输入角色名称"
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              disabled: [1, 2].includes(form.id),
              modelValue: form.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.status = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分配权限",
            prop: "perIds"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElTree), {
              "check-strictly": treeCheckStrictly.value,
              class: "w100",
              ref_key: "treeRef",
              ref: treeRef,
              onCheck: handleElCheck,
              data: _unref(allPermissionList),
              "show-checkbox": "",
              "default-expand-all": "",
              "node-key": "id",
              "highlight-current": "",
              props: {
                children: 'children',
                label: 'title'
              }
            }, null, 8, ["check-strictly", "data"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});